// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DealershipService } from '@services/dealership.service';
import { UserDealers, UserTypes } from '@interfaces/user.interfaces';
import { UserService } from './user.service';
import { DealerProducts } from '../interfaces/dealer.interfaces';

@Injectable({
    providedIn: 'root',
})
export class PreloadService {
    constructor(
        private dealershipService: DealershipService,
        private userService: UserService
    ) {}

    refreshDealerships(): void {
        this.preloadDealerships();
    }

    preloadDealerships(): void {
        try {
            this.emitDealershipsFromLocalStorageIfExists();

            if (window.location.href.includes('/pddj')) {
                this.dealershipService.getUserActiveDealers$(DealerProducts.EzDocsAutomate).subscribe((dealerships) => {
                    if (dealerships?.length > 0) {
                        localStorage.setItem('ddj-user-dealers', JSON.stringify(dealerships));
                        // sets a behaviorSubject on the dealershipservice
                        this.dealershipService.dealers = dealerships;
                    }
                });
            } else {
                this.dealershipService.getUserDealers$().subscribe((dealerships) => {
                    if (dealerships?.length > 0) {
                        localStorage.setItem('ddj-user-dealers', JSON.stringify(dealerships));
                        // sets a behaviorSubject on the dealershipservice
                        if (this.userService.user.userType !== UserTypes.Internal) {
                            this.dealershipService.getUserActiveDealers$(DealerProducts.EzDocsBase).subscribe((activeDealers) => {
                                if (activeDealers?.length > 0) {
                                    this.dealershipService.dealers = dealerships.filter((dealer) => {
                                        // Check if dealerId exists in activeDealers
                                        return activeDealers.some((activeDealer) => activeDealer.dealerId === dealer.dealerId);
                                    });
                                }
                            });
                        } else {
                            this.dealershipService.dealers = dealerships;
                        }
                    }
                });
            }
        } catch (error) {
            console.error('Error in preloadDealerships: ', error);
        }
    }

    emitDealershipsFromLocalStorageIfExists(): void {
        //check for user dealerships in local storage
        const userDealershipsFromLocalStorage: UserDealers[] = JSON.parse(localStorage.getItem('ddj-user-dealers'));
        //if the dealerships in local storage have a different userId, then it was from someone logged in as a different user and we don't want to use them
        if (userDealershipsFromLocalStorage?.length > 0 && userDealershipsFromLocalStorage[0].userId === this.userService.user.userId) {
            this.dealershipService.dealers = userDealershipsFromLocalStorage;
        }
    }

    getDealerships(): Observable<UserDealers[]> {
        return this.dealershipService.dealers$;
    }
}
